var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{class:{ 'navbar': true, scroll: _vm.scroll }},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"logo",attrs:{"src":require("../../assets/images/logo.png"),"alt":"Heldengame"}})]),_c('navigation')],1)}
var staticRenderFns = []

export { render, staticRenderFns }